import React, {lazy, Suspense} from 'react'

const SpiritualityPagePageLazy = lazy(() =>
    import('./SpiritualityPage')
)

const SpiritualityPage = props => (
    <Suspense fallback={null}>
        <SpiritualityPagePageLazy {...props} />
    </Suspense>
)

export default SpiritualityPage
